import { render, staticRenderFns } from "./OrderLogPagination.vue?vue&type=template&id=625481f8"
import script from "./OrderLogPagination.vue?vue&type=script&lang=js"
export * from "./OrderLogPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports